<template>
  <div v-if="promos.length">
    <div class="banner" v-for="promo in promos" :key="promo">
      <html-with-links
        tag="p"
        class="banner__inner container"
        :html="promo"
      ></html-with-links>
    </div>
  </div>
</template>

<script>
import HtmlWithLinks from '@/components/HtmlWithLinks';

export default {
  components: {
    HtmlWithLinks,
  },
  computed: {
    promos() {
      return this.$store.getters.promos.pages;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../assets/variables";

.banner {
  position: relative;
  font-size: 20px;
  line-height: 32.5px;
  padding: 5px;
  text-align: center;
  background-color: var(--light-primary);

  &:not(:first-child) {
    border-top: 1px solid lighten($primary, 35);
  }

  @include notebook {
    font-size: 14px;
    line-height: initial;
  }

  &__inner {
    position: relative;
  }

  a {
    font-weight: 500;
    color: $primary;
  }
}
</style>
